<div
    class="flex relative items-center"
    [ngClass]="{
        'justify-start': alignTabs === 'start',
        'justify-center': alignTabs === 'center',
        'justify-end': alignTabs === 'end'
    }">
    <! -- Left scroll arrow -->
    <div
        *ngIf="(scroll.showArrows$ | async) && (scroll.left.disable$ | async) === false"
        class="border-r-0 h-tab flex justify-center items-center"
        [ngClass]="{
            'border-tab': includeContainer,
            'border-solid': includeContainer
        }">
        <span
            porIcon
            class="cursor-pointer text-text-base hover:text-text-focus h-[25px]"
            (mousedown)="startScroll('left')"
            (mouseup)="stopScroll('left')"
            [icon]="scroll.left.icon"
            [height]="25"
            [width]="25"></span>
    </div>

    <div #tabsBox class="flex border-l-tab border-solid border-y-0 border-r-0 max-w-full overflow-x-hidden">
        <ng-content></ng-content>
    </div>

    @if (includeContainer) {
        <div class="flex-grow h-tab border-tab border-solid border-t-0 border-l-0 border-r-0"></div>
    }
    <! -- Right scroll arrow -->
    <div
        *ngIf="(scroll.showArrows$ | async) && (scroll.right.disable$ | async) === false"
        class="h-tab flex justify-center items-center"
        [ngClass]="{
            'border-tab': includeContainer,
            'border-solid': includeContainer
        }">
        <span
            porIcon
            class="cursor-pointer text-text-base hover:text-text-focus h-[25px]"
            (mousedown)="startScroll('right')"
            (mouseup)="stopScroll('right')"
            [icon]="scroll.right.icon"
            [height]="25"
            [width]="25"></span>
    </div>
</div>

@if (includeContainer) {
<div class="p-default border-solid border-tab border-t-0">
    <ng-template [cdkPortalOutlet]="selectedPortal"></ng-template>
</div>
} @else { }
